<template>
	<div class="hook-container">
		<transition name="fade">
			<div class="loading" v-if="hookLoading" v-loading="true"></div>
		</transition>

		<div class="hook" :ref="`hook_${entidad || componente || 'hook'}`"></div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { mapActions } from 'vuex'
	import { getUrl } from '@/helpers/api'

	export default {
		name: 'HookCustom',
		props: {
			entidad: String,
			id: String,
			ficha: [String, Object],
			porlet: Object,
			componente: String
		},
		data() {
			return {
				hookLoading: false
			}
		},
		mounted () {

			this.$nextTick(async () => {
				
				this.hookLoading = true

                let component = null
                try {
                    component = (await import( /* webpackIgnore: true */ process.env.NODE_ENV === 'production' ? `./hooks/${this.componente}/script.js` : `./js/hooks/${this.componente}/script.js`)).default
                } catch(e) {
                    component = null
				}
				
				const hookRefName = `hook_${this.entidad || this.componente || 'hook'}`
				const hookRef = this.$refs[hookRefName]
				if(component && hookRef) {
					const ComponentClass = Vue.extend(component)
					
					const instance = new ComponentClass({
						propsData: {
							url: getUrl(),
							id: this.id,
							ficha: this.ficha,
							entidad: this.entidad,
							entidadRelacionada: this.porlet && this.porlet.entidadRelacionada,
							...this.$attrs
						}
					})

					instance.$on('updateFicha', (data) => this.$emit('updateFicha', data))
					instance.$on('reloadDataTable', (data) => this.$emit('reloadDataTable', data))
					instance.$on('loginsuccess', (data) => this.$emit('loginsuccess', data))

					instance.$mount()
					
					hookRef.appendChild(instance.$el)

					this.$addRef('custom', instance) // Guardar referencia
					
				}
				
				await new Promise((resolve, reject) => setTimeout(() => { resolve() }, 500))
				
				this.hookLoading = false
				

			})

		}
	}
</script>

<style lang="scss">
.hook-container {
	height: 100%;
	.loading {
		position: absolute;
		background-color: white;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		width: 100%;
		height: 100%;
		z-index: 9999;
	}
	.hook {
		height: 100%;
		min-height: 70px!important;
	}
}

.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}	
</style>